var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',_vm._b({staticClass:"full-width",attrs:{"value":_vm.$props.value},on:{"input":_vm.input,"blur":_vm.blur,"change":_vm.change}},'el-input',_vm.overrideAttrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }